import React from "react";
import Translate from "localization/Translate";

export default function ({listItems}) {
    return (
        <table className={"responsiveTable bold borderBottomTd documentTable"}>
            <thead style={{
                fontSize: '1.43rem',
                borderBottom: "0.142857rem solid rgb(235, 235, 235)"
            }}>
            <tr>
                <th><Translate id={"Product"}/></th>
                <th><Translate id={"Item code"}/></th>
                <th><Translate id={"Quantity"}/></th>
                <th><Translate id={"Total"}/></th>
            </tr>
            </thead>
            <tbody>
            {
                listItems.map((item, index) => {
                    return (
                        <tr
                            key={index}
                            className={"productLine"}
                        >
                            <td>
                                {item.product.itemName}
                            </td>
                            <td>
                                {item.product.code}
                            </td>
                            <td>
                                {item.product.amount}
                            </td>
                            <td>
                                {item.product.rowTotal}
                            </td>
                        </tr>
                    );
                })
            }
            </tbody>
        </table>
    );
}
